import { useCallback } from 'react';

import { TrackingApi } from 'api/TrackingApi';
import { getScreenOrientationWithSizes } from 'helpers/device';

const QuizFunnelAnalyticsInfo = 'mainstream_quiz';

export const useQuizFunnelAnalytics = () => {
  const trackQuizShow = useCallback(() => {
    TrackingApi.trackPopup({
      info: QuizFunnelAnalyticsInfo,
      operation: 'show',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  const trackQuizHide = useCallback(() => {
    TrackingApi.trackPopup({
      info: QuizFunnelAnalyticsInfo,
      operation: 'hide',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  const trackQuizSkip = useCallback(({ step }: { step: number }) => {
    TrackingApi.trackPopup({
      info: QuizFunnelAnalyticsInfo,
      operation: 'click',
      value: step,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  const trackQuizAnswer = useCallback(
    ({ step, answer }: { step: number; answer: any }) => {
      TrackingApi.trackPopup({
        info: QuizFunnelAnalyticsInfo,
        operation: 'click',
        value: step,
        parameter: JSON.stringify(answer),
        screen: getScreenOrientationWithSizes(),
      }).catch();
    },
    []
  );

  return {
    trackQuizShow,
    trackQuizHide,
    trackQuizSkip,
    trackQuizAnswer,
  };
};
